module.exports = __webpack_public_path__ + "static/media/CardExample3.6be3b609.png";